import React from 'react';
import NPPanel from '../../NPPanel';
import { Button, Form, FormGroup, FormControl, Col, Row, InputGroup, ButtonGroup } from 'react-bootstrap';
import axios from 'axios';
import constants from '../.././util/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faEye, faEyeSlash, faTimes } from '@fortawesome/free-solid-svg-icons'
import { hasGrant } from '../../util/grantHelper';
import * as Grants from '../../util/grants';
import Select from 'react-select';
import '../style.scss';
import classHelper from '../../util/class.helper'
import TelephoneNumber from '../../CountryPicker';

import UserGrants from './UserGrants';

const { API_BASE_URL } = constants;

class CreateUser extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            user: {
                UserName: '',
                Id: '',
                Email: '',
                Settings: {
                    UserId: '',
                    MarketAreaCode: '',
                    HasAccess: true,
                    UserType: 0,
                    Grants: [],
                    Roles: []
                },
                AuthSettings: {
                    UserId: '',
                    UseTwoFactor: true,
                    OtpMethod: 0,
                    PhoneNumber: null,
                    PhoneCountryCode: null,
                    SessionExpirationDays: null,
                    ResetSession: false
                },
                ClientCodeRegional: ''
            },
            showPortalPassword: false,
            createdUser: false,
            updatedUser: false,
            showError: false,
            loaded: true,
            errorMessage: '',
            isBoxCorrect: true,
            isNew: true,
            caption: 'Create New User',
            header: {
                'Authorization': 'Bearer ' + this.props.apiToken,
                'Accept': 'application/octet-stream'
            }
        };
        this.handleClientSelectChange = this.handleClientSelectChange.bind(this);
        this.handleChangeUserName = this.handleChangeUserName.bind(this);
        this.handleChangeEmail = this.handleChangeEmail.bind(this);
        this.handleChangePortalPassword = this.handleChangePortalPassword.bind(this);
        this.handleChangeMAC = this.handleChangeMAC.bind(this);
        this.handleTwofactorExpirationChange = this.handleTwofactorExpirationChange.bind(this);
        this.handleTwoFactorToggle = this.handleTwoFactorToggle.bind(this);
        this.handleTwoFactorResetToggle = this.handleTwoFactorResetToggle.bind(this);
        this.createUser = this.createUser.bind(this);
        this.updateUser = this.updateUser.bind(this);
        this.close = this.close.bind(this);
        this.toggleLocked = this.toggleLocked.bind(this);
        this.getExpirationDaysOptions = this.getExpirationDaysOptions.bind(this);
        this.setCountryCode = this.setCountryCode.bind(this);
        this.setPhoneNumber = this.setPhoneNumber.bind(this);
        this.resetSession = this.resetSession.bind(this);
    }

    componentDidMount() {
        this.axiosCancelSource = axios.CancelToken.source();
        this.getUser();
    }

    componentWillUnmount() {
        this.axiosCancelSource.cancel('Component unmounted.')
    }

    getDefaultAuthSettings() {
        return {
            UserId: '',
            UseTwoFactor: true,
            OtpMethod: 0,
            PhoneNumber: '',
            SessionExpirationDays: null,
            ResetSession: false
        }
    }

    getUser() {
        let id = (this.props.id === undefined || this.props.id === "") ? '' : '?id=' + this.props.id;

        if (this.props.id != 0) {
            axios.get(API_BASE_URL + 'Admin/GetUser' + id, { headers: this.state.header, cancelToken: this.axiosCancelSource.token })
                .then(result => {
                    result.data.AuthSettings = result.data.AuthSettings && result.data.AuthSettings != null ? result.data.AuthSettings : this.getDefaultAuthSettings();
                    this.setState({ loaded: true, user: result.data, caption: 'Modify User', isNew: false, });
                    this.handleClientSelectChange(this);
                }).catch(response => { });
        }
    }

    toggleLocked() {
        let id = (this.props.id === undefined || this.props.id === "") ? '' : '?id=' + this.props.id;
        axios.get(API_BASE_URL + 'Admin/ToggleLock' + id, { headers: this.state.header, cancelToken: this.axiosCancelSource.token })
            .then(result => {
                this.getUser(this.state.user.Id);
            }).catch(response => { });
    }

    createUser() {
        const portalUser = {};
        portalUser['User'] = this.state.user;
        portalUser['Base'] = process.env.REACT_APP_BASE_CATALOG;


        axios.post(API_BASE_URL + 'Admin/CreateUser', portalUser, { headers: this.state.header, cancelToken: this.axiosCancelSource.token })
            .then(response => {
                if (response.data != null) {
                    this.setState({ showError: false, loaded: true, createdUser: true, errorMessage: '' });
                } else {
                    this.setState({ showError: true })
                }

            }).catch(error => {
                let message = error && error.response && error.response.data ? error.response.data.Message : 'Unknown error.';
                this.setState({ showError: true, errorMessage: message })
            });
    }

    updateUser() {
        let id = (this.props.id === undefined || this.props.id === "") ? '' : this.props.id;
        let password = (this.state.user.Password === undefined || this.state.user.Password === "") ? '' : this.state.user.Password;
        if (id && password) {
            axios.post(API_BASE_URL + 'Admin/SetPassword', this.state.user, { headers: this.state.header, cancelToken: this.axiosCancelSource.token })
                .then(response => {
                    if (response.data != null) {
                        this.setState({ showError: false, loaded: true, updatedUser: true, errorMessage: '' });
                    } else {
                        this.setState({ showError: true })
                    }
                }).catch(error => {
                    let message = error && error.response && error.response.data ? error.response.data.Message : 'Unknown error.';
                    this.setState({ showError: true, errorMessage: message, updatedUser: false })
                    return;
                });
        }

        axios.post(API_BASE_URL + 'Admin/UpdateUser', this.state.user, { headers: this.state.header, cancelToken: this.axiosCancelSource.token })
            .then(response => {
                if (response.data != null) {
                    this.setState({ showError: false, loaded: true, updatedUser: true, errorMessage: '' });
                } else {
                    this.setState({ showError: true })
                }

            }).catch(error => {
                let message = error && error.response && error.response.data ? error.response.data.Message : 'Unknown error.';
                this.setState({ showError: true, errorMessage: message, updatedUser: false })
            });

    }

    resetSession() {
        let self = this;
        let path = 'TwoFactor/ResetSession?userId=' + encodeURIComponent(this.state.user.Id);
        axios.post(API_BASE_URL + path, null, { headers: this.state.header, cancelToken: this.axiosCancelSource.token })
            .then(result => {
                self.setState({ loaded: true, updatedUser: true });
            }).catch(response => { });
    }

    getMarketCodes() {
        let self = this;

        axios.get(API_BASE_URL + 'Admin/GetMarketCodes', { headers: this.state.header, cancelToken: this.axiosCancelSource.token })
            .then(result => {
                let MACodes = result.data;
                self.setState({ loaded: true, data: result.data });
            }).catch(response => { });
    }


    addCCRToList() {
        //If Client code regional has a value we add it to the list. 
        if (this.state.CCR) {
            let i;
            let j = true;

            for (i = 0; i < this.state.user.ClientCodeRegional.length; i++) {
                if (this.state.user.ClientCodeRegional[i] === this.state.CCR) {
                    this.setState({ showError: true, errorMessage: 'CCR-number must be unique.' });
                    j = false;
                    break;
                }
            }

            if (j) {
                var user = { ...this.state.user }
                this.state.user.ClientCodeRegional ?
                    user.ClientCodeRegional = [...this.state.user.ClientCodeRegional, this.state.CCR]
                    : user.ClientCodeRegional = [this.state.CCR]
                this.setState({ user, showError: false })
            }

        } else {
            this.setState({ showError: true, errorMessage: 'Enter CCR-number.' })
        }

    }

    removeCCRFromList(number) {
        if (this.state.user.Settings.HasAccess == false)
            return;
        var index = this.state.user.ClientCodeRegional.indexOf(number);
        if (index > -1) {
            this.state.user.ClientCodeRegional.splice(index, 1);
        }
        this.setState({ showError: false })
        this.forceUpdate();
    }


    handleChangeUserName(event) {
        let user = { ...this.state.user }
        user.UserName = event.target.value;
        this.setState({ user });
    }

    handleChangeEmail(event) {
        let user = { ...this.state.user }
        user.Email = event.target.value;
        this.setState({ user });
    }

    setPhoneNumber(number) {
        let user = { ...this.state.user };
        user.AuthSettings.PhoneNumber = number;
        this.setState({ user });
    }

    setCountryCode(cc) {
        let user = { ...this.state.user };
        user.AuthSettings.PhoneCountryCode = cc;
        this.setState({ user });
    }

    handleChangePortalPassword(event) {
        let user = { ...this.state.user }
        user.Password = event.target.value;
        this.setState({ user });
    }

    handleChangeMAC(event) {
        let MAC = event.target.value;
        this.setState(prevState => ({
            ...prevState,
            user: {
                ...prevState.user,
                Settings: {
                    ...prevState.user.Settings,
                    MarketAreaCode: MAC
                }
            }
        })
        );
    }

    handleClientSelectChange(event) {
        // Gör en koll på vilken roll som är satt. 
        let value = '';
        if (this.state.user && this.state.user.Id != undefined && this.state.user.Id != '') {
            if (this.state.user.Settings.UserType === 1) {
                value = 'Internal';
            }
            else if (this.state.user.Settings.UserType === 2) {
                value = 'Agent';
            }
            else if (this.state.user.Settings.UserType === 3) {
                value = 'Customer';
            }
        }
        // Om ett userid inte är medskickat så sätt värdet efter vad användaren väljer i dropdown.
        else {
            value = event.target.value;
        }

        if (value == "Internal") {
            this.setState(prevState => ({
                ...prevState,
                user: {
                    ...prevState.user,
                    Settings: {
                        ...prevState.user.Settings,
                        UserType: 1
                    }
                }
            }),
            );
            this.setState({ value: 'Internal' });
        }
        else if (value == "Agent") {
            this.setState(prevState => ({
                ...prevState,
                user: {
                    ...prevState.user,
                    Settings: {
                        ...prevState.user.Settings,
                        UserType: 2
                    }
                }
            })
            );
            this.setState({ value: 'Agent' });
        }
        else if (value == "Customer") {
            this.setState(prevState => ({
                ...prevState,
                user: {
                    ...prevState.user,
                    Settings: {
                        ...prevState.user.Settings,
                        UserType: 3
                    }
                }
            })
            );
            this.setState({ value: 'Customer' });
        }
        this.setState({ loaded: true })
    }

    handleTwofactorExpirationChange(event) {
        let input = event === null ? 0 : event.label === '' ? 0 : event.value;
        let user = { ...this.state.user }
        user.AuthSettings.SessionExpirationDays = input;
        this.setState({ user });
    }

    handleTwofactorOtpChange(event) {
        let user = { ...this.state.user };
        user.AuthSettings.OtpMethod = event.value;
        this.setState({ user })
    }

    handleTwoFactorToggle(value) {
        let user = { ...this.state.user };
        user.AuthSettings.UseTwoFactor = value;
        this.setState({ user });
    }

    handleTwoFactorResetToggle(value) {
        let user = { ...this.state.user };
        user.AuthSettings.ResetSession = value;
        this.setState({ user });
    }

    showPortalPassword() {
        this.state.showPortalPassword &&
            this.state.showPortalPassword == true ?
            this.setState({ showPortalPassword: false })
            : this.setState({ showPortalPassword: true })
    }

    close() {
        this.props.viewUserCommand(0, 0);
        let authSettings = this.getDefaultAuthSettings();

        this.setState({
            user: {
                UserName: '',
                Id: '',
                Email: '',
                Settings: {
                    UserId: '',
                    MarketAreaCode: '',
                    HasAccess: true,
                },
                ClientCodeRegional: '',
                AuthSettings: authSettings
            },
            showPortalPassword: false,
            createdUser: false,
            updatedUser: false,
            showError: false,
            loaded: true,
            errorMessage: '',
            phoneNumber: null,
            countryCode: null,
            caption: 'Create New User',
            header: {
                'Authorization': 'Bearer ' + this.props.apiToken,
                'Accept': 'application/octet-stream'
            }
        })
    }

    grantAccess(userId) {
        let user = {
            Id: userId
        };
        const portalUser = {};
        portalUser['User'] = user;
        portalUser['Base'] = process.env.REACT_APP_BASE_CATALOG;

        let self = this;

        axios.post(API_BASE_URL + 'Admin/GrantAccess', portalUser, { headers: this.state.header, cancelToken: this.axiosCancelSource.token })
            .then(result => {
                self.setState({ loaded: true, grantAccess: true });
                this.close();
            }).catch(response => { });
    }

    denyAccess(userId) {
        let id = (userId === undefined || userId === "") ? '' : userId;
        let self = this;

        axios.get(API_BASE_URL + `Admin/DenyAccess?id=${id}`, { headers: this.state.header, cancelToken: this.axiosCancelSource.token })
            .then(result => {
                self.setState({ loaded: true, data: result.data });
                this.close();
            }).catch(response => { });
    }

    getExpirationDaysOptions() {
        let array = Array(7).fill().map((_, i) => { let index = i; return { label: index * 5, value: index * 5 } });
        array.unshift({ label: "Server default", value: null });
        return array;
    }

    render() {
        const { showError } = this.state;
        let editable = ((hasGrant(Grants.TYPES.Admin_ModifyUsers) && this.state.caption === 'Modify User') || (hasGrant(Grants.TYPES.Admin_CreateUsers) && this.state.caption === 'Create New User'));
        let disabled = editable === false || this.state.user.Settings.HasAccess === false;
        return (
            <div className="create-user">
                {this.state.loaded &&
                    <NPPanel>
                        <section>
                            <div className="center-block text-center user-heading"> {this.state.caption} </div>
                        </section>
                        <Row>
                            <Col sm={12}>
                                <Row className="margin-top-10">
                                    <Form horizontal autoComplete="off">
                                        <section>
                                            <FormGroup controlId="formHorizontalUsername" bsSize="small">
                                                <Col sm={6}>
                                                    <label>Email</label>
                                                    <FormControl className={showError && !this.state.user.Email ? "form-control error" : "form-control"} type="email" placeholder="Email" disabled={disabled} value={this.state.user.Email ? this.state.user.Email : ''} onChange={this.handleChangeEmail} />
                                                </Col>
                                                {this.props.id != 0 && this.state.user.Settings.HasAccess &&
                                                    <Col sm={6}>
                                                        <label>New Portal Password</label>
                                                        {this.state.showPortalPassword ?
                                                            <div className="flex">
                                                                <FormControl type="text" placeholder="Portal Password" disabled={disabled} value={this.state.user.Password ? this.state.user.Password : ''} onChange={this.handleChangePortalPassword} />
                                                                <Button bsStyle="primary" bsSize="small" className="pull-right" onClick={() => { this.showPortalPassword(); }}> <FontAwesomeIcon icon={faEye} /></Button>
                                                            </div>
                                                            :
                                                            <div className="flex">
                                                                <FormControl type="password" placeholder="Portal Password" disabled={disabled} value={this.state.user.Password ? this.state.user.Password : ''} onChange={this.handleChangePortalPassword} />
                                                                <Button bsStyle="primary" bsSize="small" className="pull-right" onClick={() => { this.showPortalPassword(); }}><FontAwesomeIcon icon={faEyeSlash} /></Button>
                                                            </div>
                                                        }
                                                    </Col>
                                                }
                                            </FormGroup>
                                        </section>
                                        <section>
                                            <FormGroup controlId="formHorizontalRole" bsSize="small">
                                                <Col sm={6}>
                                                    {this.state.user && this.state.user.Settings.UserType !== 1 && this.state.user.Settings.HasAccess &&
                                                        <div>
                                                            <label>Client Code Regional</label>
                                                            <div className="flex">
                                                                <FormControl className={showError && !this.state.user.ClientCodeRegional ? "form-control error" : "form-control"} type="text" placeholder="Client Code Regional" disabled={disabled} onChange={evt => { this.setState({ CCR: evt.target.value }) }} />
                                                                <Button bsStyle="primary" bsSize="small" className="pull-right" onClick={() => { this.addCCRToList(); }}>Add CCR</Button>
                                                            </div>
                                                        </div>
                                                    }
                                                    {this.state.user && this.state.user.Settings.UserType === 1 &&
                                                        <div>
                                                            <label>Market Area Code</label>
                                                            <FormControl type="text" placeholder="Market Area Code" value={this.state.user && this.state.user.Settings.MarketAreaCode ? this.state.user.Settings.MarketAreaCode : ''} disabled={disabled} onChange={this.handleChangeMAC} />
                                                        </div>
                                                    }
                                                    {
                                                        this.state.user &&
                                                        this.state.user.Settings.UserType !== 1 &&
                                                        this.state.user.ClientCodeRegional &&
                                                        this.state.user.ClientCodeRegional.length > 0 &&
                                                        !this.state.user.Settings.HasAccess &&
                                                        <div>
                                                            <label>Client Code Regional</label>
                                                            <ul className="CCRList">
                                                                {this.state.user.ClientCodeRegional.map((number) =>
                                                                    <li className="form-control" key={number.toString()} disabled={disabled} >{number}
                                                                        {this.state.user.Settings.HasAccess &&
                                                                            <FontAwesomeIcon icon={faTimes} pull="right" className="CCR-times" onClick={() => { this.removeCCRFromList(number); }} />
                                                                        }
                                                                    </li>)
                                                                }
                                                            </ul>
                                                        </div>
                                                    }
                                                </Col>
                                                <Col sm={6}>
                                                    <label>User type</label>
                                                    <select className={showError && !this.state.value ? "form-control error" : "form-control"} disabled={this.props.id != 0 ? true : false} onChange={this.handleClientSelectChange} value={this.state.value ? this.state.value : 0}>
                                                        <option value="None">-- Choose user type --</option>
                                                        <option value="Internal">Internal</option>
                                                        <option value="Agent">Agent</option>
                                                        <option value="Customer">Customer</option>
                                                    </select>
                                                </Col>
                                            </FormGroup>
                                            <FormGroup controlId="formHorizontalCCR" bsSize="small">
                                                <Col sm={6}>
                                                    {this.state.user &&
                                                        this.state.user.Settings.UserType !== 1 &&
                                                        this.state.user.ClientCodeRegional &&
                                                        this.state.user.ClientCodeRegional.length > 0 &&
                                                        this.state.user.Settings.HasAccess &&
                                                        <div className="paddT">
                                                            <label>Client Code Regional</label>
                                                            <ul className="CCRList">
                                                                {this.state.user.ClientCodeRegional.map((number) =>
                                                                    <li className="form-control" key={number.toString()} >{number} <FontAwesomeIcon icon={faTimes} pull="right" className="CCR-times" onClick={() => { this.removeCCRFromList(number); }} /></li>)
                                                                }
                                                            </ul>
                                                        </div>
                                                    }
                                                </Col>
                                            </FormGroup>
                                            {!this.state.isNew &&
                                                <FormGroup>
                                                    <Col sm={12}>
                                                        <Col sm={4}>
                                                            <Row>
                                                                Created by: {this.state.user.Settings.CreatedBy}
                                                            </Row>
                                                            <Row>
                                                                Created: {this.state.user.Settings.Created === null ? '' : new Date(this.state.user.Settings.Created).toLocaleString()}
                                                            </Row>
                                                        </Col>
                                                        <Col sm={4}>
                                                            <Row style={{ paddingLeft: '15px' }}>
                                                                Modified by: {this.state.user.Settings.UpdatedBy}
                                                            </Row>
                                                            <Row style={{ paddingLeft: '15px' }}>
                                                                Modified: {this.state.user.Settings.Updated === null ? '' : new Date(this.state.user.Settings.Updated).toLocaleString()}
                                                            </Row>
                                                        </Col>
                                                        <Col sm={4}>
                                                            <Row>
                                                            &nbsp;
                                                            </Row>
                                                            <Row>
                                                                Last login: {this.state.user.Settings.LastLogon === null ? '' : new Date(this.state.user.Settings.LastLogon).toLocaleString()}
                                                            </Row>
                                                        </Col>
                                                    </Col>
                                                </FormGroup>}
                                        </section>
                                        <section>
                                            {hasGrant(Grants.TYPES.Admin_EditTwoFactorSettings) &&
                                                <legend className="center-block text-center user-heading">Two factor settings</legend>
                                            }
                                        </section>
                                        <section>
                                            {hasGrant(Grants.TYPES.Admin_EditTwoFactorSettings) &&
                                                <FormGroup controlId="form2Selects" bsSize="small">
                                                    <Col sm={6} className="margin-top-20">
                                                        <InputGroup>
                                                            <span className="input-group-addon">Session length</span>
                                                            <Select placeholder="Days before reauthentication"
                                                                styles={classHelper.dropdownStyleLarge()}
                                                                isClearable={false}
                                                                options={this.getExpirationDaysOptions()}
                                                                menuContainerStyle={{ zIndex: 5 }}
                                                                value={{ label: this.state.user && this.state.user.AuthSettings && this.state.user.AuthSettings.SessionExpirationDays === null ? "Server default" : this.state.user.AuthSettings.SessionExpirationDays }}
                                                                onChange={(item) => this.handleTwofactorExpirationChange(item)}
                                                            />
                                                        </InputGroup>
                                                    </Col>
                                                    <Col sm={6} className="margin-top-20">
                                                        <InputGroup>
                                                            <span className="input-group-addon">Delivery Method</span>
                                                            <Select placeholder="Method.."
                                                                isClearable={false}
                                                                options={[{ label: "SMS", value: 0 }, { label: "Email", value: 1 }]}
                                                                menuContainerStyle={{ zIndex: 5 }}
                                                                value={{ label: this.state.user.AuthSettings.OtpMethod === 0 ? "SMS" : "Email" }}
                                                                onChange={(item) => this.handleTwofactorOtpChange(item)}
                                                            />
                                                        </InputGroup>
                                                    </Col>
                                                </FormGroup>
                                            }
                                        </section>
                                        <section>
                                            {hasGrant(Grants.TYPES.Admin_EditTwoFactorSettings) &&
                                                <FormGroup controlId="form2UseOTP" bsSize="small">
                                                    <Col sm={3}>
                                                        <InputGroup toggle="toggle">
                                                            <InputGroup.Addon>Use two factor</InputGroup.Addon>
                                                            <div style={{ height: '38px' }} className="np-switch-wrapper">
                                                                <span className="np-switch" style={{ height: '38px' }}>
                                                                    <input type="checkbox"
                                                                        style={{ height: '38px' }}
                                                                        value={this.state.user.AuthSettings.UseTwoFactor}
                                                                        checked={this.state.user.AuthSettings.UseTwoFactor}
                                                                        onChange={(e) => this.handleTwoFactorToggle(e.target.value)} />
                                                                    <span style={{ height: '38px' }} className="slider" onClick={() => this.handleTwoFactorToggle(!this.state.user.AuthSettings.UseTwoFactor)}></span>
                                                                </span>
                                                            </div>
                                                        </InputGroup>
                                                    </Col>
                                                </FormGroup>
                                            }
                                        </section>
                                        <section>
                                            {hasGrant(Grants.TYPES.Admin_EditTwoFactorSettings) &&
                                                <TelephoneNumber setCc={this.setCountryCode} setNumber={this.setPhoneNumber} countryCode={this.state.user.AuthSettings.PhoneCountryCode} phoneNumber={this.state.user.AuthSettings.PhoneNumber} />
                                            }
                                        </section>
                                        <section>
                                            <FormGroup controlId="formHorizontalMessage">
                                                <Col sm={12}>
                                                    {this.state.createdUser &&
                                                        <div>
                                                            <label><FontAwesomeIcon icon={faCheck} /> User is created</label>
                                                        </div>
                                                    }
                                                    {this.state.updatedUser &&
                                                        <div>
                                                            <label><FontAwesomeIcon icon={faCheck} /> User is Updated</label>
                                                        </div>
                                                    }
                                                    {this.state.showError &&
                                                        <div>
                                                            <label className="danger"><FontAwesomeIcon icon={faTimes} /> Error: {this.state.errorMessage}</label>
                                                        </div>
                                                    }
                                                </Col>
                                                <div className="margin-top-10">
                                                    <Col sm={6} xs={6}>
                                                        {this.state.user.Settings.HasAccess &&
                                                            <span>
                                                                {this.state.user && this.state.user.Id && hasGrant(Grants.TYPES.Admin_ModifyUsers) &&
                                                                    <Button bsStyle="primary" className="margin-right-10" onClick={this.updateUser}>Update user</Button>}
                                                                {this.state.user && this.state.user.Id && hasGrant(Grants.TYPES.Admin_EditTwoFactorSettings) &&
                                                                    <Button bsStyle="primary" className="margin-right-10" onClick={this.resetSession}>Reset 2FA session</Button>}
                                                                {!this.state.user.Id && hasGrant(Grants.TYPES.Admin_CreateUsers) &&
                                                                    <Button bsStyle="primary" className="margin-right-10" onClick={this.createUser}>Create user</Button>}
                                                            </span>
                                                        }
                                                        <Button bsStyle="primary" onClick={this.close}>Close</Button>
                                                    </Col>
                                                    <Col sm={6} xs={6}>
                                                        {this.props.id != 0 && this.state.user.Settings.HasAccess && hasGrant(Grants.TYPES.Admin_ModifyUsers) &&
                                                            <span>
                                                                {this.state.user.Settings &&
                                                                    this.state.user.Settings.IsLocked ?
                                                                    <Button bsStyle="danger" className="margin-left-10 pull-right" onClick={this.toggleLocked}>Unlock user</Button>
                                                                    : <Button bsStyle="danger" className="margin-left-10 pull-right" onClick={this.toggleLocked}>Lock user</Button>
                                                                }
                                                            </span>
                                                        }
                                                        {hasGrant(Grants.TYPES.Admin_ManagePendingUsers) && this.props.id != 0 && !this.state.user.Settings.HasAccess &&
                                                            <span>
                                                                <Button bsStyle="primary" className="margin-left-10 pull-right" onClick={() => { this.grantAccess(this.state.user.Id); }}>Grant Access </Button>
                                                                <Button bsStyle="danger" className="margin-left-10 pull-right" onClick={() => { this.denyAccess(this.state.user.Id); }}>Deny Access </Button>
                                                            </span>
                                                        }
                                                    </Col>
                                                </div>
                                            </FormGroup>
                                        </section>
                                    </Form>
                                </Row>
                            </Col>
                        </Row>
                    </NPPanel >
                }

                {
                    hasGrant(Grants.TYPES.Admin_ViewUserRoles) && this.state.user && this.state.user.Roles &&
                    <UserGrants header={this.state.header} user={this.state.user} close={this.close} />
                }

            </div >
        );
    }
}

export default CreateUser;